import { useContext } from 'react'
import { OwnershipCheckContext } from '../contexts'

export const useOwnershipCheckContext = () => {
  return useContext(OwnershipCheckContext)
}
